export const StatusConstant = {
    ACTIVE: 'A',
    INACTIVE: 'I',
    DELETED: 'D',
    OPEN: 'OPEN',
    USED: 'USED',
    EXPIRED: 'EXPIRED',
    SUSPENDED: 'SUSPENDED',
    VOID: 'VOID'
}